import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { customStorage } from "./CustomLocalStorage";

interface ProtectedRouteProps {
	children: React.ReactNode;
}

const basePath = location.pathname.split("/").slice(0, 3).join("/");

// ProtectedRoute component to protect routes based on authentication
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(true);
	const location = useLocation();

	useEffect(() => {
		// Check if user is logged in based on token in sessionStorage
		// const token = sessionStorage.getItem("access_token");
		const token = customStorage.getItem("access_token");
		setIsLoggedIn(!!token); // If token exists, user is logged in
	}, []);

	// If user is not logged in, save the current URL only if not already saved
	if (!isLoggedIn) {
		if (location.pathname !== "/login" && location.pathname !== "/") {
			if (basePath === "/agency-order/order-listing") {
				// Only set linkBeforelogin if it doesn't exist
				if (!customStorage.getItem("linkBeforelogin")) {
					customStorage.setItem("linkBeforelogin", location.pathname);
				}
			} else {
				// Always set (override) linkBeforelogin for other paths
				customStorage.setItem("linkBeforelogin", location.pathname);
			}
		}
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	// If logged in, render the protected route
	return children;
};

export default ProtectedRoute;
